import { bffServiceInstance } from "@/plugins/api_service/services";

const prefix = "/admin/prefectures";

export default {
  getList: () => bffServiceInstance.get(`${prefix}/get-select-list`),
  validateCode: (pref_code) =>
    bffServiceInstance.post(`${prefix}/validate`, {}, { pref_code }),
};
